module.exports = "<div class=\"modal-header\">\r\n   <h4 class=\"modal-title\"\r\n       translate>Success!</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n   <div translate>\r\n      We have emailed you a temporary password. You will be prompted to change it the next time you log in.\r\n   </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n   <rw-button variant=\"contained\"\r\n              action=\"$ctrl.confirm()\">\r\n      <translate>\r\n         OK\r\n      </translate>\r\n   </rw-button>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/components/forgot-password/views/success-confirm-modal.html
// module id = 1183
// module chunks = 0